/* eslint-disable @atlaskit/platform/one-value-export-per-file -- insert/remove share one Review moment slot id */

import {
	insertFooterItem,
	removeFooterItem,
	type ReviewMomentFooterState,
} from './messageFooterSlotStore';

export const REVIEW_MOMENT_FOOTER_SLOT_ID = 'review-moment';

export const insertReviewMomentFooter = (
	reviewMoment: ReviewMomentFooterState,
	onAction: (actionId: string) => void,
	generation?: number,
	sourceMessageId?: string,
): void => {
	insertFooterItem(
		{
			id: REVIEW_MOMENT_FOOTER_SLOT_ID,
			filter: ({ messageId }) => !!sourceMessageId && messageId === sourceMessageId,
			onAction,
			reviewMoment,
		},
		generation,
	);
};

export const removeReviewMomentFooter = (generation?: number): void => {
	removeFooterItem(REVIEW_MOMENT_FOOTER_SLOT_ID, generation);
};
